import { useState, useEffect } from 'react';
import { numberOfLessons } from 'Api/editCourseLessons';

const useModule = ({ module, deleteModule, updateModule, moduleId }) => {
  const [isDraft, setIsDraft] = useState(module.isDraft);
  const [name, setName] = useState(module.name);
  const [numberLessons, setNumberLessons] = useState(0);

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      numberOfLessons({ moduleId }).then(count => setNumberLessons(count));
    }

    return () => {
      isMounted = false;
      setNumberLessons(0);
    };
  }, []);

  const moduleDelete = () => {
    deleteModule(module.id);
  };

  const moduleUpdate = () => {
    delete module.isDraft;
    delete module.name;
    delete module.lessons;
    module.name = name;
    module.isDraft = isDraft;
    updateModule(module);
  };
  return {
    name,
    setName,
    isDraft,
    setIsDraft,
    moduleUpdate,
    moduleDelete,
    numberLessons,
  };
};

export default useModule;
